// ============================================================
// StatusDot — Brand Guide v2
//
// 6–8px dot with colored glow + optional pulse. Use `pulse={true}`
// only when the underlying state is actually live/alive. For a
// static/offline indicator pass pulse={false} and it renders as
// a muted ring (no glow) — glow is reserved for meaning.
// ============================================================

const TONE = {
  active:   '#00a67d',   // green · alive
  pending:  '#c4a24e',   // gold · pending
  deployed: '#00aad2',   // cyan · deployed/verified
  critical: '#e85d3a',   // red · critical
  offline:  'rgba(255,255,255,0.18)',
}

export default function StatusDot({
  color,
  tone,
  size = 7,
  pulse = true,
  title,
}) {
  const resolved = color || TONE[tone] || TONE.active
  const isMuted = !pulse && !color && tone === 'offline'

  return (
    <span
      role="status"
      aria-label={title}
      title={title}
      style={{
        position: 'relative',
        display: 'inline-block',
        width: size,
        height: size,
        flexShrink: 0,
      }}
    >
      <span
        style={{
          position: 'absolute',
          inset: 0,
          borderRadius: '50%',
          backgroundColor: isMuted ? 'transparent' : resolved,
          border: isMuted ? `1px solid ${resolved}` : 'none',
          // Brand Guide: glow = meaning. Only render when active/live.
          boxShadow: isMuted
            ? 'none'
            : `0 0 ${Math.max(4, size - 1)}px ${resolved}80`,
          animation: pulse ? 'sc-pulse 2s ease infinite' : 'none',
        }}
      />
    </span>
  )
}
